// extracted by mini-css-extract-plugin
module.exports = {"list":"RowBlock_list__YpHQ_","item":"RowBlock_item__cd34d"};